<template >
  <div>
    <div class="filter-box">
      <div class="filter-wrap">
        <div class="item">
          <span class="filter-label">开始时间:</span>
          <el-date-picker
            v-model="fliter_res.filter_start_time"
            type="date"
            placeholder="选择开始时间"
            value-format="timestamp"
            size="small"
            :picker-options="startDatePicker"
          >
          </el-date-picker>
        </div>
        <div class="item">
          <span class="filter-label">结束时间:</span>
          <el-date-picker
            v-model="fliter_res.filter_end_time"
            type="date"
            placeholder="选择结束时间"
            value-format="timestamp"
            size="small"
            :picker-options="endDatePicker"
          >
          </el-date-picker>
        </div>
        <div class="item">
          <span class="filter-label">姓名:</span>
          <el-input
            v-model="fliter_res.search_name"
            placeholder="请输入"
            size="small"
          ></el-input>
        </div>
        <div class="item">
          <span class="filter-label">学号:</span>
          <el-input
            v-model="fliter_res.search_student_no"
            placeholder="请输入"
            oninput="value=value.replace(/[^\w\\/]/ig,'')"
            size="small"
          ></el-input>
        </div>
      </div>
      <div class="filter-btn-group">
        <el-button type="primary" size="small" @click="$query()"
          >查询</el-button
        >
        <el-button size="small" @click="$reset()">重置</el-button>
      </div>
    </div>
    <div class="mainbody">
      <div class="top">
        <h3 class="title">回收数据</h3>
        <div class="btn-group-custom">
          <!-- <el-button type="text">删除</el-button> -->
          <el-button type="text" @click="$download()">导出</el-button>
          <el-button type="text" @click="$downloadAll()">一键导出</el-button>
          <el-button type="text" @click="$del()">删除</el-button>
        </div>
      </div>
      <div class="aLine"></div>
      <div class="box">
        <div class="tableInfo survey-list">
          <el-table
            :data="answer_list"
            v-loading="loading"
            style="width: 100%"
            :height="height"
            @selection-change="handleSelectionChange"
            @sort-change="changeTableSort"
            ref="answerList"
          >
            <el-table-column fixed type="selection" width="50" align="center">
            </el-table-column>
            <el-table-column fixed label="详情" width="70" align="center">
              <template slot-scope="scope">
                <el-button
                  class="operateText"
                  type="text"
                  @click="surveyInfo(scope.row)"
                  ><i class="el-icon-view"></i
                ></el-button>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="answer_id"
              label="编号"
              min-width="70"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              fixed
              width="120"
              sortable="custom"
              label="校友名称"
            >
            </el-table-column>

            <el-table-column
              prop="student_no"
              width="120"
              sortable="custom"
              label="校友学号"
            >
            </el-table-column>
            <el-table-column prop="updateTime" width="160" label="提交时间">
            </el-table-column>
            <el-table-column
              v-for="item in question_list"
              :key="item.id"
              :label="item.label"
              :width="item.width"
              :min-width="item.minWidth"
            >
              <template slot-scope="scope">
                <p
                  v-text="getValue(scope.row, item.id)"
                  v-if="item.type == 'text' || item.type == 'textarea'"
                ></p>
                <el-image
                  style="width: 100%; height: 60px"
                  :src="getValue(scope.row, item.id)"
                  :preview-src-list="[getValue(scope.row, item.id)]"
                  fit="contain"
                  v-if="[getValue(scope.row, item.id, true)] == 'image'"
                ></el-image>
                <a
                  target="_blank"
                  :href="getValue(scope.row, item.id)"
                  v-if="[getValue(scope.row, item.id, true)] == 'upload'"
                  >附件下载</a
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :key="elementui_page_key"
            class="elPagination"
            background
            layout="prev, pager, next"
            :page-size="pageMaxSize"
            :page-count="pageCount"
            :current-page="currentPage"
            @current-change="currentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <surveyExportAnswerList
      ref="_surveyExportAnswerList"
    ></surveyExportAnswerList>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Utils from "@/utils/utils.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import SurveyExportAnswerList from "@/components/survey/surveyExportAnswerList";

export default {
  components: {
    SurveyExportAnswerList
  },
  props: {
    survey_info: {
      type: Object
    }
  },

  data() {
    return {
      survey_id: null,
      answer_list: null,
      question_list: [], //问卷字段名
      loading: true,
      height: "650",
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      selection: [], // 已勾选导出的问卷id,
      isExport: true, // 如果数据为空则不允许导出
      // 筛选结果（未存入接口参数中）
      fliter_res: {
        filter_start_time: "",
        filter_end_time: "",
        search_name: "",
        search_student_no: "",
        order: ""
      },
      // 接口参数（查询使用）
      fliter_Params: {
        filter_start_time: "",
        filter_end_time: "",
        search_name: "",
        search_student_no: "",
        order: ""
      },
      // 时间限制
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate()
    };
  },
  methods: {
    initData() {},
    // 时间限制
    beginDate() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
        }
      };
    },
    processDate() {
      let self = this;
      return {
        disabledDate(time) {
          if (self.fliter_res["filter_start_time"]) {
            return (
              new Date(self.fliter_res["filter_start_time"]).getTime() >
                time.getTime() || time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    getAnswerList(order) {
      this.loading = true;
      let endTime = "";
      if (this.fliter_Params["filter_end_time"]) {
        endTime = this.fliter_Params["filter_end_time"] / 1000 + 86399;
      }
      this.$api
        .answerList({
          token: localStorage.getItem("token"),
          survey_id: localStorage.getItem("survey_id") || "",
          page: this.currentPage,
          limit: this.pageMaxSize,
          filter_start_time:
            this.fliter_Params["filter_start_time"] / 1000 || "",
          filter_end_time: endTime,
          search_name: this.fliter_Params["search_name"] || "",
          search_student_no: this.fliter_Params["search_student_no"] || "",
          order: this.fliter_Params["order"] || ""
        })
        .then(({ data }) => {
          let current_page = Utils.listPage(data, this.currentPage);
          if (current_page) {
            this.currentPage = current_page;
            this.getAnswerList();
          }
          this.pageCount = data.Data.pageCount;
          this.answer_list = data.Data.model;

          if (this.answer_list && this.answer_list.length == 0) {
            this.isExport = false;
          } else {
            this.isExport = true;
            this.answer_list.forEach((item) => {
              item.updateTime = Utils.dateFormat(item.update_time * 1000);
            });
          }
          if (this.question_list.length == 0) {
            this.getQuetionList();
          }
          this.loading = false;
        })
        .catch(({ error }) => {
          this.loading = false;
        });
    },
    // 问卷删除操作后重新渲染列表
    refresh(msg) {
      this.$message({
        message: msg,
        type: "success"
      });
      this.getAnswerList();
    },
    //获取问卷字段名
    getQuetionList() {
      let arr = [];
      let value = "";
      let width = 0;
      this.survey_info.fields.forEach((item, index) => {
        if (item.type != "description") {
          value = item.title;
          if (index < this.survey_info.fields.length - 1) {
            if (item.title) {
              width =
                value.length * 10 + 12 < 130 ? 130 : value.length * 10 + 12;
              this.question_list.push({
                id: item.id,
                label: value,
                width: width,
                minWidth: "",
                type: item.type
              });
            }
          } else {
            this.question_list.push({
              id: item.id,
              label: value,
              width: "",
              minWidth: 120,
              type: item.type
            });
          }
        }
      });
    },
    // 获取问卷答案值
    getValue(row, id, type) {
      if (row && row.questions && row.questions[id]) {
        if (
          row.questions[id].type != "text" &&
          row.questions[id].type != "textarea"
        ) {
          if (type) {
            return row.questions[id].type;
          } else {
            return URL_PATH + row.questions[id].text;
          }
        } else {
          return row.questions[id].text;
        }
      } else {
        return "";
      }
    },
    // 查看问卷详情
    surveyInfo(val) {
      let res = val.result;
      let questions = JSON.parse(JSON.stringify(val.questions));
      let arr = [];
      for (let i in questions) {
        let info = this.question_list.find((item) => {
          if (item.id == i) {
            return item;
          }
        });
        if (info && info.label) {
          questions[i]["label"] = info.label;
        }
        arr.push(questions[i]);
      }
      this.$root.$emit("showAnswerInfo", {
        arr: arr,
        info: val,
        flag: true,
        is_audit: this.survey_info.is_audit
      });
    },
    selectionEmpty() {
      if (this.selection.length == 0) {
        this.$message.error("至少选中一条数据");
        return true;
      }
      return false;
    },
    $downloadAll() {
      if (this.isExport) {
        this.$nextTick(() => {
          this.$refs._surveyExportAnswerList.show(
            this.survey_info.survey_id,
            null,
            this.fliter_Params
          );
        });
      } else {
        this.$message.error("未存在需要导出的数据");
      }
    },
    $download() {
      if (this.selection.length == 0) {
        this.$message.error("至少选中一条数据");
        return true;
      } else {
        this.$nextTick(() => {
          this.$refs._surveyExportAnswerList.show(
            this.survey_info.survey_id,
            JSON.stringify(this.selection)
          );
        });
      }
    },
    // 分页控制
    currentChange(val) {
      this.loading = true;
      this.elementui_page_key++;
      this.currentPage = val;
      this.getAnswerList();
    },
    // 勾选状态
    handleSelectionChange(val) {
      this.selection = [];
      if (val && val.length > 0) {
        val.forEach((item) => {
          this.selection.push(item.answer_id);
        });
      }
    },
    // 删除待审核问卷
    $del() {
      if (this.selection.length > 0) {
        this.$confirm("是否删除该问卷答案", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$api
              .delAnswer({
                token: localStorage.getItem("token"),
                survey_id: this.survey_info.survey_id,
                answer_ids: JSON.stringify(this.selection)
              })
              .then(({ data }) => {
                this.getAnswerList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              })
              .catch(({ error }) => {});
          })
          .catch(() => {});
      } else {
        this.$message.error("至少选中一条数据");
      }
    },
    $query() {
      // 将筛选参数存储到接口参数中
      this.fliter_Params = JSON.parse(JSON.stringify(this.fliter_res));
      this.getAnswerList();
    },
    $reset() {
      this.fliter_res = {
        filter_start_time: "",
        filter_end_time: "",
        search_name: "",
        search_student_no: "",
        order: ""
      };
      this.fliter_Params = {
        filter_start_time: "",
        filter_end_time: "",
        search_name: "",
        search_student_no: "",
        order: ""
      };
      this.$refs.answerList.clearSort();
      this.currentPage = 0;
      this.getAnswerList();
    },
    // 排序
    changeTableSort(column) {
      this.fliter_res["order"] = StrUtils.getPropOrder(column);
      this.fliter_Params["order"] = StrUtils.getPropOrder(column);
      this.getAnswerList();
    }
  },
  created() {
    this.height = document.documentElement.clientHeight - 390;
    this.getAnswerList();
    this.$root.$on("export_answer", (msg) => {
      this.$nextTick(() => {
        this.$refs._surveyExportAnswerList.show(
          this.survey_info.survey_id,
          JSON.stringify([msg])
        );
      });
    });
    this.$root.$off("answerList_refresh_list");
    this.$root.$on("answerList_refresh_list", (msg) => {
      this.refresh(msg);
    });
  },
  beforeDestroy() {
    this.$root.$off("export_answer");
  },
  watch: {
    "fliter_res.filter_start_time"(val) {
      if (this.fliter_res.filter_end_time < val) {
        this.$set(this.fliter_res, "filter_end_time", "");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.filter-box {
  padding: 27px 32px;
  background: #ffffff;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
}
.filter-wrap {
  display: flex;
  align-items: center;
}
.filter-wrap .item {
  margin-right: 36px;
  display: flex;
  align-items: center;
}
.filter-label {
  font-size: 14px;
  margin-right: 10px;
  white-space: nowrap;
}

.top {
  position: relative;
}
.top .btn-group-custom {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right: 32px;
}
.top .btn-group-custom .el-button--text {
  color: #595959;
}
.top .btn-group-custom .el-button--text:hover {
  color: #1890ff;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}

.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .box {
  padding: 24px 15px;
}
.box .item {
  color: #595959;
  margin-bottom: 16px;
  display: flex;
}
.box .item .text {
  flex: 1;
}
.empty {
  color: rgb(148, 148, 148);
  text-align: center;
}
.el-pagination {
  margin: 20px 0;
}
</style>
<style>
.survey-list .el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
  background: rgb(156, 156, 156);
}
.survey-list .el-table__body-wrapper::-webkit-scrollbar-corner {
  background: #efefef;
}
</style>



// WEBPACK FOOTER //
// src/components/survey/answerList.vue